module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "title": "Download messages"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('p', [_vm._v("\n    From here you can download a collection of messages defined by your parameters to a CSV file.\n  ")]), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "label-width": "120px",
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "File name",
      "prop": "fileName"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.fileName),
      callback: function($$v) {
        _vm.$set(_vm.form, "fileName", $$v)
      },
      expression: "form.fileName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Dates",
      "prop": "rangeDate"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "To",
      "start-placeholder": "Start date",
      "end-placeholder": "End date"
    },
    model: {
      value: (_vm.form.rangeDate),
      callback: function($$v) {
        _vm.$set(_vm.form, "rangeDate", $$v)
      },
      expression: "form.rangeDate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Channels",
      "prop": "channels"
    }
  }, [_c('channel-select', {
    attrs: {
      "channels": _vm.channelLinks,
      "selectedChannels": _vm.form.channels
    },
    on: {
      "onSelectedChannelsChanged": _vm.handleSelectedChannelsChanged
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.handleRunDownloadMessages
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v("\n      Download\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-98f8aeae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/campaign/DownloadMessagesDialog.vue
// module id = 3373
// module chunks = 3